<template>
  <div class="viewresult-container" :class="{ 'max-width': cancelHeight }">
    <div
      :style="{
        backgroundImage:
          informationObj.bgImageStatus === 'success'
            ? 'url(' + bgSuccess + ')'
            : informationObj.bgImageStatus === 'unsuccess'
            ? 'url(' + bgUnsuccess + ')'
            : 'url(' + bgNo + ')',
      }"
      ref="bg"
      class="bg-container"
      :class="{ beike: isBeike }"
    >
      <common-header
        class="header"
        :content="content"
        v-if="!showPDFStyle"
      ></common-header>
      <div class="bg-container-title" :class="{ 'add-top': !cancelHeight }">
        <span :class="{ subjectTitle: showPDFStyle }" class="subject">{{
          informationObj.subjectName
        }}</span>
        <span class="time">考试时间：{{ informationObj.examTime }}</span>
      </div>
      <div class="circle-container">
        <div :class="{ circleAdd: classAdd }" class="circle">
          <div class="small-circle" :class="{ smallAdd: classAdd }">
            <div class="font-container">
              <div class="score-container">
                <span class="score">{{
                  informationObj.bgImageStatus === "no"
                    ? "--"
                    : informationObj.bgImageStatus === "invalid"
                    ? "0"
                    : informationObj.grade
                }}</span>
              </div>
              <span
                v-show="
                  informationObj.bgImageStatus !== 'no' &&
                  informationObj.bgImageStatus !== 'invalid'
                "
                class="fen"
                >分</span
              >
            </div>
            <div
              v-if="false"
              :style="{
                color:
                  informationObj.bgImageStatus === 'success' ||
                  informationObj.bgImageStatus === 'unsuccess'
                    ? '#257fff'
                    : '#A3A3A3',
              }"
              class="status"
            >
              <span>
                {{
                  informationObj.bgImageStatus === "success"
                    ? "参考"
                    : informationObj.bgImageStatus === "unsuccess"
                    ? "参考"
                    : informationObj.bgImageStatus === "invalid"
                    ? "违纪"
                    : "缺考"
                }}</span
              >
            </div>
            <div
              v-if="!isBeike"
              :style="{
                color:
                  informationObj.bgImageStatus === 'success'
                    ? '#33D3A7'
                    : informationObj.bgImageStatus === 'unsuccess'
                    ? '#FB8875'
                    : '#A3A3A3',
              }"
              class="status"
            >
              <span>
                {{
                  informationObj.bgImageStatus === "success"
                    ? "合格"
                    : informationObj.bgImageStatus === "unsuccess"
                    ? "不合格"
                    : informationObj.bgImageStatus === "invalid"
                    ? "成绩无效"
                    : "缺考"
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{ bottomAdd: classAdd }"
        v-if="JSON.stringify(scoreObj).length !== 2"
        class="bottom"
      >
        <div class="left">
          <img :src="Manfen" alt="满分" />
          <span>满分{{ scoreObj.totalScore }}分</span>
        </div>
        <div class="left">
          <img :src="questionCount" alt="题目数" />
          <span>共{{ scoreObj.questionCount }}题</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Manfen from "img/manfen.png";
import questionCount from "img/questionCount.png";
import bgSuccess from "@/img/bg-success.png";
import bgUnsuccess from "@/img/bg-unsuccess.png";
import bgNo from "@/img/bg-no.png";
import CommonHeader from "@/components/commonHeader.vue";
import { ref, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "CommonBgImage",
  components: { CommonHeader },
  props: {
    content: {
      type: String,
      required: true,
    },
    // 信息对象
    informationObj: {
      type: Object,
      required: true,
    },
    // 满分和题数的对象
    scoreObj: {
      type: Object,
      default() {
        return {};
      },
    },
    // 是否要展示PDFstyle
    showPDFStyle: {
      type: Boolean,
      default: false,
    },
    // 导出pdf页面取消掉高度调整marginTop的负值大小
    cancelHeight: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    let classAdd = ref(false);
    const bodyHeight = document.body.clientHeight;
    if (bodyHeight < 600) {
      classAdd.value = true;
    }
    // 定义store
    const store = useStore();

    const isBeike = computed(() => {
      return store.getters.isBeike;
    });
    //
    const PDFStyle = ref({
      fontSize: "40px",
    });
    return {
      bgSuccess,
      bgUnsuccess,
      bgNo,
      Manfen,
      questionCount,
      classAdd,
      PDFStyle,
      isBeike,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "scss/base.scss";
.viewresult-container {
  width: 100%;
  height: 570px;
  display: flex;
  flex-direction: column;
  align-items: center;
  &.max-width {
    height: 666px;
    max-height: 330px;
  }
  .bg-container {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    &.beike {
      background: linear-gradient(#299bfd, #257fff) !important;
    }
    &-title {
      display: flex;
      flex-direction: column;
      color: #fff;
      align-items: center;
      &.add-top {
        margin-top: 30px;
      }
      .subject {
        font-size: 44px;
        width: 80%;
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        &.subjectTitle {
          font-size: 37px;
        }
      }
      .time {
        font-size: 28px;
        margin-top: 25px;
      }
    }
    .circle-container {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-top: 2%;
      .circle {
        @include flex-center;
        width: 280px;
        height: 280px;
        border-radius: 50%;
        border: 10px solid #fff;
        &.circleAdd {
          width: 240px;
          height: 240px;
        }
        .small-circle {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 220px;
          height: 220px;
          border-radius: 50%;
          &.smallAdd {
            width: 190px;
            height: 190px;
          }
          .status {
            @include flex-center;
            padding: 8px 18px;
            font-size: 33px;
            background-color: #fff;
            border-radius: 25px;
            color: #33d3a7;
            box-sizing: border-box;
          }
          .font-container {
            display: flex;
            .score-container {
              display: flex;
              color: #fff;
              flex-direction: column;
              margin-bottom: 10px;
              align-items: center;

              .score {
                font-size: 85px;
              }
            }
            .fen {
              display: flex;
              align-items: center;
              font-size: 30px;
              opacity: 0.8;
              color: #fff;
              padding-top: 10px;
            }
          }
        }
      }
    }
    .bottom {
      width: 100%;
      box-sizing: border-box;
      position: absolute;
      display: flex;
      padding: 0 15px;
      justify-content: space-between;
      bottom: 14%;
      // margin-top: -8px;
      &.bottomAdd {
        margin-top: -7%;
      }
      .left {
        display: flex;
        color: #fff;
        img {
          width: 24px;
          height: 24px;
        }
        span {
          font-size: 25px;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
